// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__k0Sj4","navItem":"nav_navItem__HfnIH"};